import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function AccountPanel() {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (next !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password updated");
      setCur(""); setNext(""); setConfirm(""); setDone(true);
      setTimeout(() => setDone(false), 4000);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="account-panel" className="max-w-xl">
      <div className="rounded-2xl border border-border bg-card p-8">
        <div className="flex items-center gap-3 mb-2">
          <KeyRound className="h-5 w-5 text-accent" strokeWidth={1.5}/>
          <h2 className="font-display text-2xl">Change your password</h2>
        </div>
        <p className="text-sm text-muted-foreground mb-6">
          Use at least 8 characters. Pick something a stranger couldn't guess.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="cur-pw">Current password</Label>
            <Input id="cur-pw" data-testid="current-password-input" type="password" required value={cur} onChange={(e) => setCur(e.target.value)}/>
          </div>
          <div>
            <Label htmlFor="new-pw">New password</Label>
            <Input id="new-pw" data-testid="new-password-input" type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)}/>
          </div>
          <div>
            <Label htmlFor="confirm-pw">Confirm new password</Label>
            <Input id="confirm-pw" data-testid="confirm-password-input" type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)}/>
          </div>
          <Button data-testid="change-password-submit-btn" type="submit" disabled={loading} className="bg-primary hover:bg-primary/90 rounded-full px-6">
            {loading ? "Updating…" : "Update password"}
          </Button>
          {done && (
            <div data-testid="change-password-success" className="flex items-center gap-2 text-sm text-emerald-700 pt-1">
              <CheckCircle2 className="h-4 w-4"/> Password updated successfully.
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
